"use client";

import { cn } from "@/lib/utils";
import { Slot } from "@radix-ui/react-slot";
import { motion } from "motion/react";
import React from "react";
import type { WrapperProps } from "./types";

function Wrapper({
  padding = "",
  margin = "",
  border = "",
  shadow = "",
  rounded = "",
  background = "",
  asChild = false,
  className = "",
  children,
  ...props
}: WrapperProps) {
  const wrapperClasses = cn(
    padding,
    margin,
    border,
    shadow,
    rounded,
    background,
    className,
  );

  const Comp = asChild ? motion.create(Slot) : motion.div;

  return (
    <Comp className={wrapperClasses} {...props}>
      {children}
    </Comp>
  );
}

Wrapper.displayName = "Wrapper";

export default React.memo(Wrapper);
